import { Map } from 'immutable';
import { SOURCE_ID } from '../../constants/sourceId';
export function transformBetSlip(betSlip) {
    var rate = betSlip.get('rate');
    return new Map({
        betNum: betSlip.get('betNum'),
        eventId: rate.get('matchId'),
        eventTimeAndZone: betSlip.getIn(['match', 'timeAndZone']),
        outcomeId: rate.get('outcomeId'),
        factorId: rate.get('id'),
        factorValue: rate.get('value'),
        isConditional: false,
        isFix: false
    });
}
export function createBetModel(couponAmount, user, betType, rank, isFreebet, factors, bettingMode, lang, freebetId) {
    if (isFreebet === void 0) { isFreebet = false; }
    var gamblerId = user.gamblerId;
    var accountId = user.accountId;
    var sourceId = SOURCE_ID;
    var allowIncrease = bettingMode.acceptIncrease; //TODO: to implement
    var allowDecrease = bettingMode.acceptDecrease; //TODO: to implement
    var oneClick = false; //TODO: to implement
    var basketBet = {
        rank: rank,
        amount: couponAmount,
        isFreebet: isFreebet,
        type: betType,
        factors: factors
    };
    if (isFreebet && freebetId !== undefined) {
        basketBet.idFreebet = freebetId;
    }
    return {
        gamblerId: gamblerId,
        accountId: accountId,
        oneClick: oneClick,
        allowIncrease: allowIncrease,
        allowDecrease: allowDecrease,
        sourceId: sourceId,
        basketBet: basketBet,
        lang: lang
    };
}
export function createMultiSingleBetModel(couponAmount, user, betType, rank, isFreebet, factors, bettingMode, lang, freebetId) {
    if (isFreebet === void 0) { isFreebet = false; }
    var gamblerId = user.gamblerId;
    var accountId = user.accountId;
    var sourceId = SOURCE_ID;
    var allowIncrease = false; //TODO: to implement
    var allowDecrease = false; //TODO: to implement
    var oneClick = false; //TODO: to implement
    var basketBets = [];
    factors.map(function (factor) {
        var betNum = factor.get('betNum');
        factor = factor.delete('betNum');
        var basketBet = {
            betNum: betNum,
            type: betType,
            rank: rank,
            amount: couponAmount,
            isFreebet: isFreebet,
            oneClick: oneClick,
            allowIncrease: allowIncrease,
            allowDecrease: allowDecrease,
            factors: [factor]
        };
        if (isFreebet && freebetId !== undefined) {
            basketBet.idFreebet = freebetId;
        }
        basketBets.push(basketBet);
    });
    return {
        gamblerId: gamblerId,
        accountId: accountId,
        sourceId: sourceId,
        basketBets: basketBets,
        lang: lang
    };
}
export function getSelectedFreebet(freebets, selectedFreebetId) {
    return freebets.find(function (item) { return item.id === selectedFreebetId; }) || freebets[0] || {};
}
export function formatFreebetDate(dateTimeString) {
    if (!dateTimeString)
        return '';
    var _a = dateTimeString.split('T'), datePart = _a[0], _b = _a[1], timePart = _b === void 0 ? '' : _b;
    var _c = datePart.split('-'), year = _c[0], month = _c[1], day = _c[2];
    return "".concat(day, ".").concat(month, ".").concat(year, ", ").concat(timePart.slice(0, 5));
}



// WEBPACK FOOTER //
// ./src/components/coupon/utils.js